var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLikeIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4375 3.96875C18.4062 5.65625 18.5 8.65625 16.75 10.4688L10.6875 16.7188C10.5 16.9062 10.25 17 9.96875 17C9.71875 17 9.46875 16.9062 9.28125 16.7188L3.21875 10.4688C1.46875 8.65625 1.5625 5.65625 3.53125 3.96875C5.53125 2.28125 8.09375 3.09375 9.375 4.40625L10 5.03125L10.5938 4.40625C12.1875 2.75 14.7188 2.53125 16.4375 3.96875ZM16.0312 9.78125C17.2188 8.53125 17.4688 6.1875 15.7812 4.75C14.0625 3.28125 12.0312 4.34375 11.3125 5.09375L10 6.46875L8.65625 5.09375C7.90625 4.34375 5.90625 3.28125 4.1875 4.75C2.5 6.1875 2.75 8.53125 3.9375 9.78125L10 16.0312L16.0312 9.78125Z",
    fill: "#F7F7F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeIcon1);
export default __webpack_public_path__ + "static/media/likeIcon1.cd614836cacbb1e88de62dadc761b43f.svg";
export { ForwardRef as ReactComponent };